import {
  makeStyles,
  createStyles,
  InputAdornment,
  TextField,
  TextFieldProps,
  Theme,
  SvgIcon,
} from "@material-ui/core";
import { SearchIcon } from "~components/Icons";

export type SearchProps = {} & TextFieldProps;

export const Search = (props: SearchProps) => {
  const classes = useStyles();

  return (
    <TextField
      id="standard-start-adornment"
      className={classes.textField}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" className={classes.icon}>
            <SvgIcon component={SearchIcon} />
          </InputAdornment>
        ),
        classes: {
          root: classes.root,
          input: classes.input,
        },
        disableUnderline: true,
      }}
      placeholder="Search..."
      variant="standard"
      {...props}
    />
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 48,
    },
    textField: {
      boxShadow: "0 1px 1px 0 rgba(51, 91, 130, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)",
      backgroundColor: "white",
      borderRadius: 2,
      paddingLeft: theme.spacing(2.5),
      "&:hover": {
        boxShadow: "0 1px 1px 0 rgba(51, 91, 130, 0.24), 0 0 1px 0 rgba(10, 31, 68, 0.2)",
      },
    },
    icon: {
      color: theme.palette.primary.main,
      "& svg": {
        fontSize: 24,
      },
    },
    input: {
      fontSize: 16,
      lineHeight: 1,
      height: "auto",
      paddingTop: theme.spacing(1.75),
      paddingBottom: theme.spacing(1.5),
      paddingRight: theme.spacing(2.5),
      minWidth: 180,
    },
  }),
);
